var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBackArrowWithTail = function SvgBackArrowWithTail(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 9.167H4.512l4.47-4.47a.833.833 0 1 0-1.179-1.179L1.911 9.411a.841.841 0 0 0-.104.127c-.014.02-.023.043-.035.065-.014.026-.03.05-.041.078-.012.028-.019.057-.027.086-.007.024-.016.045-.02.07a.831.831 0 0 0-.017.163v.002a.84.84 0 0 0 .016.161c.005.025.015.048.022.073.008.027.014.056.026.082.012.03.028.056.043.083.011.02.02.041.033.06.03.047.066.09.105.129l5.892 5.892a.834.834 0 0 0 1.178-1.179l-4.47-4.47H17.5a.833.833 0 0 0 0-1.666Z",
    fill: "var(--color-primary-800)"
  })));
};
export default SvgBackArrowWithTail;